import React from "react";
import { Redirect } from 'react-router-dom';
import { Routes } from '../Core/Constants';
import { UserProvider } from './../Providers/UserProvider';
import { CartProvider } from './../Providers/CartProvider';
import { ReturnRequestProvider } from './../Providers/ReturnRequestProvider';
import ReturnRequest from './ReturnRequest.jsx';

function WithdrawalSection({ order, onWithdrawal, withdrawalLoading, onCancel }) {
	const T = window.Texts.returnRequest;
	const state = order.withdrawalButtonState;
	const contactEmail = order.handlingStoreEmail;

	if (!state) return null;

	if (state === 'HasRequest') {
		return (
			<>
				<span style={{ marginLeft: '16px', fontSize: '13px', color: '#888' }}>
					{T.requestStatus}: {T['status' + order.returnRequestStatus]}
				</span>
				<button onClick={onWithdrawal} disabled={withdrawalLoading} className="btn btn50" style={{ marginLeft: '8px' }}>
					{T.withdrawalBtn}
				</button>
			</>
		);
	}
	if (state === 'WithinPeriod') {
		return (
			<button onClick={onWithdrawal} disabled={withdrawalLoading} className="btn btn50" style={{ marginLeft: '8px' }}>
				{T.withdrawalBtn}
			</button>
		);
	}
	if (state === 'CanCancel') {
		return (
			<span style={{ marginLeft: '16px', fontSize: '13px', color: '#888' }}>
				{T.withdrawalCanCancelText}{' '}
				<button onClick={onCancel} className="btn btn50" style={{ fontSize: '12px', marginLeft: '4px' }}>
					{T.withdrawalCanCancelBtn}
				</button>
			</span>
		);
	}
	if (state === 'NotDelivered') {
		return (
			<button onClick={onWithdrawal} disabled={withdrawalLoading} className="btn btn50" style={{ marginLeft: '8px' }}>
				{T.withdrawalBtn}
			</button>
		);
	}
	if (state === 'AfterPeriod') {
		return (
			<span style={{ marginLeft: '16px', fontSize: '13px', color: '#888' }}>
				{T.withdrawalAfterPeriodText}{' '}
				{contactEmail && <a href={'mailto:' + contactEmail}>{T.contactUs}</a>}
			</span>
		);
	}
	return null;
}

export default class Order extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            order: null,
            redirectToCart: false,
            withdrawalLoading: false
        };
    }
    componentDidMount = () => {
      
		UserProvider.getOrder(this.props.id, (data) => {
			window.gtm.loadAccount("order");
            this.setState({ order: data });
        })

    }

    handleWithdrawal = () => {
        this.setState({ withdrawalLoading: true });
        ReturnRequestProvider.getAccessForOrder(
            this.props.id,
            (data) => this.setState({ withdrawalRedirectToken: data.accessToken }),
            () => this.setState({ withdrawalLoading: false })
        );
    }

    handleCancel = () => {
        const T = window.Texts.orders;
        if (confirm(T.cancelQuestion)) {
            const order = this.state.order;
            const [invc, time] = order.publicIdentifier.split('/');
            UserProvider.cancelOrder(invc, time);
            this.setState({ redirectToOrders: true });
        }
    }

    addOrderToCart = () => {
        CartProvider.addOrderToCart(this.state.order, () => {
            this.setState({ redirectToCart: true });
        });

    }

    render() {
        if (this.props.token)
            return <ReturnRequest token={this.props.token} />;

        let order = this.state.order;
        let T = window.Texts.orders;
        if (!order)
            return <div>{T.loading}</div>;

        if (this.state.withdrawalRedirectToken)
            return <Redirect to={Routes.ReturnRequest + '?token=' + this.state.withdrawalRedirectToken} />;
        
        if (this.state.redirectToCart)
            return <Redirect to={Routes.Cart} />

        if (this.state.redirectToOrders)
            return <Redirect to={Routes.Orders} />
        return (
            <div className="order-detail-page">
                <div className="cover">
                    <div className="headline">
                        <h1>{T.orderTitle + ' : ' + order.invoiceCode}</h1>
                    </div>
                    <ul className="details">
                        <li><span>{T.acceptedDay + ':'}</span>{order.created}</li>
                        <li>
                            <span>{T.state + ':'}</span>
                            {order.displayState}
                        </li>
                    </ul>
                    <table className="table">
                        <tbody>
                            {order.orderedProducts.map((orderedProduct) => {
                                return <tr>
                                    <td className="thumb">
                                        <div className="inner">
                                            <img src={orderedProduct.thumbUrl} />
                                        </div>
                                    </td>
                                    <td className="name">
                                        <div className="inner">
                                            {orderedProduct.product ?
                                                <a className="no-line underline" href={orderedProduct.product.url} title={orderedProduct.productName}>
                                                    <u>{orderedProduct.productName}</u>
                                                </a> :
                                                <div className="no-line underline">
                                                    <u>{orderedProduct.productName}</u>
                                                </div>}
                                        </div>
                                    </td>
                                    <td className="count">
                                        {orderedProduct.count} x
                        </td>
                                    <td className="price">
                                        <div className="inner">
                                            <span>{orderedProduct.priceTable.displayTotalPriceInclVat}</span>
                                            <small>{orderedProduct.priceTable.displayTotalPriceExclVat}
                                                bez DPH</small>
                                        </div>
                                    </td>
                                    <td className="remove" />
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <div className="cart-summary">
                        <ul>
                            <li className="call2action" />
                            <li className="price-button">

                                <div className="price">
                                    <h4>{order.priceTable.displayTotalPriceInclVat}</h4>
                                    <p>{order.priceTable.displayTotalPriceExclVat} bez DPH</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <form name="order" method="post" onSubmit={this.addOrderToCart}>
                        <div>
                            <div className="buttons">
                                <button type="submit" className="btn btn50 iconed icon-continue AddOrderToCart">
                                    <span>{T.addOrderToCart}</span>
                                </button>
                                <WithdrawalSection
                                    order={order}
                                    onWithdrawal={this.handleWithdrawal}
                                    withdrawalLoading={this.state.withdrawalLoading}
                                    onCancel={this.handleCancel}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

